import { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { TbSourceCode } from "react-icons/tb";
import formatMoney from "../../../../utils/formatMoney";
import { capitalize } from "lodash";
import UpdateStatus from "./UpdateStatus";
import UpdateTitle from "./UpdateTitle";
import UpdatePrice from "./UpdatePrice";

export default function DealBasics({ deal, deal_id, access }: any) {
  const [statusModal, setStatusModal] = useState<boolean>(false);
  const [priceModal, setPriceModal] = useState<boolean>(false);
  const [titleModal, setTitleModal] = useState<boolean>(false);
  return (
    <div className="">
      <div className="flex justify-start items-center bg-white p-2 border-b-4 border-gray-300 mb-1 h-10">
        <div className="font-bold text-sm">
          {deal?.contact?.name?.toUpperCase()}
        </div>
      </div>
      <div className="">
        <div className="bg-white border p-4 mb-1 flex flex-col justify-start">
          <div className="flex flex-col justify-center">
            <div className="flex justify-between">
              <div className="font-bold text-xl">
                {deal?.title || "-"}
                {access && (
                  <button onClick={() => setTitleModal(true)} className="px-1">
                    <FiEdit size={15} />
                  </button>
                )}
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex justify-start items-center">
                <div className="text-gray-600">
                  $ {formatMoney(deal?.value || 0)}
                </div>
                {access && (
                  <button onClick={() => setPriceModal(true)} className="px-1">
                    <FiEdit />
                  </button>
                )}
              </div>
              <div className="flex justify-center  items-center">
                <div className="">{capitalize(deal?.status?.state)}</div>
                {access && (
                  <button onClick={() => setStatusModal(true)} className="px-1">
                    <FiEdit />
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center mt-4">
            <div className="flex items-center">
              <TbSourceCode />
              <span className="text-gray-600 font-bold ml-1">
                Lead Source :{" "}
              </span>
            </div>
            <span className="ml-4 text-gray-500 text-xs">
              {deal?.source?.name || "-"}
            </span>
          </div>
        </div>
      </div>

      <UpdateStatus
        isVisible={statusModal}
        setVisible={setStatusModal}
        deal={deal}
        deal_id={deal_id}
      />
      <UpdateTitle
        isVisible={titleModal}
        setVisible={setTitleModal}
        deal={deal}
        title={deal?.title || ""}
        deal_id={deal_id}
      />
      <UpdatePrice
        isVisible={priceModal}
        setVisible={setPriceModal}
        deal={deal}
        value={deal?.value || ""}
        deal_id={deal_id}
      />
    </div>
  );
}
